import { IpService } from "./../../services/ip.service";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import {
  BehaviorSubject,
  catchError,
  debounceTime,
  fromEvent,
  map,
  of,
  switchMap,
  take,
} from "rxjs";
import { FormDragAndDropInterface } from "../../common/shared-kernel";
import { DocumentTemplateComponent } from "../../document-template/document-template.component";
import { PdfService } from "../../services/pdf.service";
import { StatusType } from "../../shared/status/status.component";
import { EvergreenService } from "./evergreen.service";
import { Title } from "@angular/platform-browser";
import { DeviceService } from "src/app/services/device.service";

@Component({
  selector: "fpt-evergreen",
  templateUrl: "./evergreen.component.html",
  styleUrls: ["./evergreen.component.scss"],
})
export class EvergreenComponent implements OnInit {
  private key: string = "";
  document$ = new BehaviorSubject<FormDragAndDropInterface | undefined>(
    undefined
  );
  status$ = new BehaviorSubject<StatusType | undefined>(undefined);
  documentForm: FormGroup = new FormGroup({});
  isPreview = this.route.snapshot.data["isPreview"];
  isError = false;
  loading: any = { 1: false, 2: false, 3: false, 4: false };
  ip!: string;
  error: string = "";

  @ViewChild(DocumentTemplateComponent)
  documentTemplateForm!: DocumentTemplateComponent;

  constructor(
    private readonly evergreenService: EvergreenService,
    private readonly pdfService: PdfService,
    private readonly route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private ipService: IpService,
    private el: ElementRef,
    private title: Title,
    private readonly deviceService: DeviceService
  ) {}

  ngOnInit(): void {
    this.title.setTitle("Fit Pro Tracker Digital Documents");

    // if(!this.deviceService.isValidDevice()){
    //   this.status$.next("browser");
    //   return;
    // }

    this.key = this.route.snapshot.params["key"];

    if (!this.key) {
      return;
    }

    this.ipService.getIp().subscribe((data: any) => {
      this.ip = data.ip;
    });

    this.evergreenService
      .getDocumentTemplate(this.key)
      .pipe(
        catchError(() => {
          // this.loading[i] = false;
          this.status$.next("error");
          return of();
        })
      )
      .subscribe(template => {
        this.document$.next(template);
      });
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);

      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement =
      this.el.nativeElement.querySelector(".ng-invalid");

    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: "smooth",
    });

    fromEvent(window, "scroll")
      .pipe(debounceTime(100), take(1))
      .subscribe(() => firstInvalidControl.focus());
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  submit(i: number): void {
    if (this.isPreview) {
      return;
    }

    this.isError = false;
    this.error = "";

    // stop here if form is invalid
    if (!this.documentForm?.valid) {
      this.validateAllFormFields(this.documentForm);
      this.documentForm.markAllAsTouched();
      this.scrollToFirstInvalidControl();
      return;
    }

    this.loading[i] = true;

    this.evergreenService
      .submit(this.key, {
        content: JSON.stringify(this.document$.value),
        pdfFileBase64: "", // remove the base64 string
      })
      .pipe(
        catchError(error => {
          this.error = error.error && error.error.exceptionMessage ? error.error.exceptionMessage : "";
          this.loading[i] = false;
          this.isError = true;
          this.cd.detectChanges();
          return of();
        })
      )
      .subscribe(() => {
        this.loading[i] = false;
        this.status$.next("submitted");
        this.document$.next(undefined);
        this.cd.detectChanges();
      });

    // FIXME: Expression has changed after it was checked. Previous value for 'disabled': 'false'. Current value: 'true'.
    // this.pdfService
    //   .convertHtmlToPdfBase64(
    //     this.documentTemplateForm.getFormElement(),
    //     this.ip
    //   )
    //   .pipe(
    //     switchMap(base64 => {
    //       return this.evergreenService.submit(this.key, {
    //         content: JSON.stringify(this.document$.value),
    //         pdfFileBase64: base64,
    //       });
    //     }),
    //     catchError(error => {
    //       this.loading[i] = false;
    //       this.isError = true;
    //       this.cd.detectChanges();
    //       return of();
    //     })
    //   )
    //   .subscribe(() => {
    //     this.loading[i] = false;
    //     this.status$.next("submitted");
    //     this.document$.next(undefined);
    //     this.cd.detectChanges();
    //   });
  }
}
